import { defineMessages } from 'react-intl';

const scope = 'footerLabels';

export default defineMessages({
  userGuides: {
    id: `${scope}.user_guides`,
    defaultMessage: 'User guides',
  },
  contactMessage: {
    id: `${scope}.contact_message`,
    defaultMessage: 'Message Centre',
  },
  contactPhone: {
    id: `${scope}.contact_phone`,
    defaultMessage: 'Telephone Numbers',
  },
  userGuideDesc: {
    id: `${scope}.user_guide_desc`,
    defaultMessage: 'Find guides about our services',
  },
  contactMessageDesc: {
    id: `${scope}.contact_message_desc`,
    defaultMessage: 'Securely send and receive service requests',
  },
  contactPhoneDesc: {
    id: `${scope}.contact_phone_desc`,
    defaultMessage: 'Call HSBC Customer Support',
  },
});
